import { BaseError } from './BaseError';

/**
 * Any core functionality-related error
 */
export class CoreError extends BaseError {
    _reason;

    /**
     * @param {string} [message]
     * @param {null | Error | string | Record<string, any>} [reason]
     * @constructs CoreError
     */
    constructor(message, { reason } = {}) {
        super(message, { reason });
        this.name = 'CoreError';
        this._reason = reason;
    }

    /**
     *
     * @return {*}
     */
    get reason() {
        return this._reason;
    }
}
